import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import consts from '../../constant';

const getHeaders = () => ({
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem("Jetix")}`,
    },
});

export const fetchAllKyc = createAsyncThunk(
    'kyc/fetchAllKyc',
    async (params, { rejectWithValue }) => {
        try {
            const queryParams = new URLSearchParams(params).toString();
            const response = await axios.get(`${consts.BackendUrl}/allKyc?${queryParams}`, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const verifyKyc = createAsyncThunk(
    'kyc/verifyKyc',
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${consts.BackendUrl}/verify-kyc`, data, getHeaders());
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const kycSlice = createSlice({
    name: 'kyc',
    initialState: {
        kycList: [],
        total: 0,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllKyc.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllKyc.fulfilled, (state, action) => {
                state.loading = false;
                state.kycList = action.payload.result.docs || [];
                state.total = action.payload.result.totalDocs || 0;
            })
            .addCase(fetchAllKyc.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(verifyKyc.pending, (state) => {
                state.loading = true;
            })
            .addCase(verifyKyc.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(verifyKyc.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default kycSlice.reducer;
